import React from 'react'

let colPicker = {
    position: 'relative',
    width: '36px',
    height: '36px',
    border: 'solid 1px #DDDDDD',
    borderRadius: '6px'
};

let colBox = {
    width: '30px',
    height: '30px',
    border: '1px solid white',
    cursor: 'pointer',
    borderRadius: '3px',
    margin: '2px auto'
};

class ColPicker extends React.Component {

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            id: props.id,
            color: props.color,
            onChange: props.onChange
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            id: nextProps.id,
            color: nextProps.color,
            onChange: nextProps.onChange
        });
    }

    submit(color) {
        this.state.onChange(this.state.id, color);
    }

    componentDidMount() {
        var submit = this.submit;
        var color = this.state.color;
        $('#color-box-' + this.state.id).colpick({
            colorScheme: 'dark',
            layout: 'rgbhex',
            color: color.substring(1),
            submitText: '确定',
            onSubmit: function (hsb, hex, rgb, el) {
                $(el).css('background-color', '#' + hex);
                $(el).colpickHide();
                submit('#' + hex)
            },
            onShow: function (ele) {
                $(ele).css({
                    'top': '0',
                    'left': '32px',
                    'z-index': '100'
                })
            }
        }).css('background-color', color);
    }

    render() {
        return (
            <div style={colPicker}>
                <div style={colBox} id={'color-box-' + this.state.id} className='color-box'></div>
            </div>
        )
    }
}

export default ColPicker